import { render, staticRenderFns } from "./starbuck.vue?vue&type=template&id=6f028678&scoped=true&"
import script from "./starbuck.vue?vue&type=script&lang=js&"
export * from "./starbuck.vue?vue&type=script&lang=js&"
import style0 from "./starbuck.vue?vue&type=style&index=0&id=6f028678&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f028678",
  null
  
)

export default component.exports